import DOMPurify from "dompurify";

const EDITOR_ALLOWED_TAGS = [
    "p",
    "br",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "strong",
    "b",
    "em",
    "i",
    "u",
    "s",
    "strike",
    "code",
    "pre",
    "blockquote",
    "ul",
    "ol",
    "li",
    "a",
    "img",
    "table",
    "thead",
    "tbody",
    "tr",
    "th",
    "td",
    "span",
    "div"
];

const EDITOR_ALLOWED_ATTR = [
    "href",
    "target",
    "rel",
    "src",
    "alt",
    "style",
    "class",
    "colspan",
    "rowspan"
];

export const sanitizeEditorHtml = (html: string): string =>
    DOMPurify.sanitize(html, {
        ALLOWED_TAGS: EDITOR_ALLOWED_TAGS,
        ALLOWED_ATTR: EDITOR_ALLOWED_ATTR,
        ADD_DATA_URI_TAGS: ["img"]
    });
